import React from 'react'
import { Link } from 'gatsby'
import {
  Layout,
  Intro,
  SectionTitle,
  Showcase,
  Header,
} from '../../../../components'

import './style.scss'
import data from './data.json'

export default () => {
  return (
    <>
      <Header
        exclusive={true}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      />
      <Layout
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <Intro>
          <p>
            Breadcrumbs are a secondary navigation asset used to show a user
            their current location in an information architecture. Pages are
            represented as a horizontal list, starting from a top level and
            ending with the current location. The current page is displayed as
            plain text, while the top level and levels of organization in
            between are hyperlinks.
          </p>
        </Intro>
        <SectionTitle>Variants</SectionTitle>
        <Showcase
          site={data.site}
          title="Breadcrumb"
          text={
            <p>
              The breadcrumb consists of a horizontal row of links, except for
              the current page, separated by close angle brackets to indicate
              hierarchy levels. Each link has the same states and behavior as
              the{' '}
              <Link
                className="link"
                to={'/' + data.site + '/components/link/design'}
              >
                link
              </Link>{' '}
              component
            </p>
          }
        >
          <div className="c-breadcrumb">
            <ul>
              <li>
                <a href="#" className="c-link">
                  Breadcrumb One
                </a>
              </li>
              <li>
                <a href="#" className="c-link">
                  Breadcrumb Two
                </a>
              </li>
              <li>Breadcrumb Three</li>
            </ul>
          </div>
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <p>
          Breadcrumbs are located at the top left of a page, beneath the header
          and primary navigation and above the page title. Breadcrumb trails
          should not wrap. The asset is small to place it lower in the visual
          hierarchy.
        </p>
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Breadcrumbs should be identical to page titles to avoid any confusion.
          Use title case for breadcrumb text.
        </p>
      </Layout>
    </>
  )
}
